import type { Theme } from '@mui/material';

export const styles = {
  wrapper: {
    justifyContent: 'space-between',
    p: 2,
    flexGrow: 1,
    maxWidth: '100%',
    height: '100%',
  },

  headlineWrapper: {
    minHeight: '2.5rem',
  },

  headline: (theme: Theme) => ({
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '1.25rem',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    overflow: 'hidden',
    marginBottom: theme.spacing(1),

    [theme.breakpoints.up('lg')]: {
      fontSize: 18,
      lineHeight: '1.325em',
    },
  }),

  squareElement: (color: string) => ({
    width: '0.75rem',
    height: '0.75rem',
    marginRight: '0.5rem',
    aspectRatio: '1/1',
    backgroundColor: color,
  }),

  subline: (theme: Theme) => ({
    fontSize: 12,
    color: theme.colors.neutral[600],
    maxWidth: '100%',
    lineHeight: '0.75rem',
    marginBottom: theme.spacing(1),
  }),

  doughnutWidgetContent: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
  },

  label: {
    fontWeight: 500,
    fontSize: 14,
    justifyContent: 'center',
  },

  labelText: {
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
  },

  percentage: (theme: Theme) => ({
    color: theme.colors.neutral[600],
  }),
};
